"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const ListItemContainer = (props) => {
    const { children, index, numColumns = 1 } = props;
    const hasEndSpacing = index % numColumns < numColumns - 1;
    const flex = 1 / numColumns;
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.container, { flex }, hasEndSpacing && styles.endSpacing]) }, children));
};
exports.default = ListItemContainer;
const styles = react_native_1.StyleSheet.create({
    container: {
        marginBottom: styles_1.getSpacing(),
    },
    endSpacing: {
        marginEnd: styles_1.getSpacing(),
    },
});
